export enum PresentationType {
	Chart = 'chart',
	Custom = 'custom',
	Grid = 'grid',
	History = 'history',
	Preview = 'preview',
}
